import React from "react";
import ReactDom from "react-dom";
import { Navigation, Link } from "react-router";
import Api from "js/utilities/fnapi-client";
import { ZOOM_ICON } from "js/config.jsx";
import { getQueryString } from "js/utilities/get-query-string";
import UserHandler from "js/utilities/user-handler";
import Amplitude from "js/utilities/amplitude";
import Loader from "react-loader";
import * as config from "../../config";
import LogErrrorsToZoomCloud from "js/utilities/log-errors-to-zc"

export default React.createClass({
  mixins: [Navigation],

  statics: {
    includeHeaderFooter: false
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  componentWillMount: function() {
    if (!UserHandler.loggedIn()) {
      return this.context.router.push("/signin");
    }

    // The user already has an app, push them on to docs!
    // In the future...do we want people to be able to create multiple apps here?
    // if (UserHandler.hasManagedApplication()) {
    //   return this.context.router.push("/docs");
    // }
  },

  getInitialState: function() {
    return {
      error: null,
      loading: false
    };
  },

  render: function() {
    return (
      <div className="bg">
        <div className="signin">
          <div className="box">
            <div className="header">
              <img src={ZOOM_ICON} className="img"/>
              <p className="title">developer account</p>
            </div>

            <p className="sub-title">Creating your first application</p>

            <div className="submit-buttons">
              {this.createFirstApplication()}
            </div>
            {this.state.error != null ? <p className="loginerror">{this.state.error}</p> : ""}
          </div>
        </div>
      </div>
    );
  },

  createFirstApplication: function(companyType) {

    let newApplicationPayload = {
      name: "Your Sample App"
    };

    // Instantiate Loggly
    _LTracker.push({
      "logglyKey": "98508576-85af-467e-8713-9ae93891800c",
      "tag" : "sdksite_debug_logs",
      "sendConsoleErrors": true
    });

    UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - start");

    // Send up application name as param
    var reqBody = newApplicationPayload;

    // Not sure where this should be in the scope
    var localContextThis = this;

    Api.post('application', newApplicationPayload).then( ( response ) => {

      if(!response.meta || !response.meta.ok) {

        //
        // Check to see if ok exists but is false.  also check to make sure there is a message.
        // this is the case of "expected error"
        // we should show what this is to the user since it could be
        // something like their auth token has already been used (common)
        //
        if(response.meta.ok === false) {
          UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onload - meta response not ok - fatal - 1703");
          UserHandler.setErrorMessage("There was an error (1703) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
          localContextThis.context.router.push("/signin");
          return;
        }
        else {
          UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onload - malformed response meta - fatal - 1705");
          UserHandler.setErrorMessage("There was an error (1703) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
          localContextThis.context.router.push("/signin");
          return;
        }
      }

      if(!response || !response.data) {
        UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onload - email send response incorrect 2 - fatal - 1710");
        UserHandler.setErrorMessage("There was an error (1710) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
        localContextThis.context.router.push("/signin");
        return;
      }

      // If we made it this far, we should be ok, just kick them back to the /account page, they should now have a new application
      // @TODO: This is where we used to have users "Accept terms and conditions" and give us a company name
      // It seems that this is no longer where that should happen, maybe it should happen on the first view of the /account page???
      localContextThis.context.router.push("/account");



    });




    // Get user token which should have been set
    // var initialUserToken = localStorage.getItem("zoom_sdk_initial_user_token");
    // if(!initialUserToken) {
    //   UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - not able to get initial user token - fatal - 1712");
    //   UserHandler.setErrorMessage("There was an error (1712) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
    //   localContextThis.context.router.push("/signin");
    //   return;
    // }

    // initialUserToken = JSON.parse(initialUserToken);

    // var requestStartTime = Date.now();
    // var request = new XMLHttpRequest();
    // request.open(method, fullURL, true);
    // request.setRequestHeader("Content-Type", "application/json");
    // request.setRequestHeader("Accept", "application/json");
    // request.setRequestHeader("X-App-Token", "sSzGgFdJBW2x6tkwxlRErBfLuDmjXYqd");
    // request.setRequestHeader("X-User-Token", initialUserToken);

    // var reqHeaders = {
    //   "Content-Type": "application/json",
    //   "Accept": "application/json",
      // "X-App-Token": "sSzGgFdJBW2x6tkwxlRErBfLuDmjXYqd",
      // "X-User-Token": initialUserToken
    // }

    // var localContextThis = this;
    //
    // request.onerror = function() {
    //   UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onerror 1 - fatal - 1701");
    //   var apiCallTimeEndToEnd = Date.now() - requestStartTime;
    //
    //   UserHandler.logToLogglyWithAPIResponse(
    //     "first-application.jsx - createFirstApplication - onerror 2 - fatal - 1701",
    //     method,
    //     fullURL,
    //     reqHeaders,
    //     reqBody,
    //     "No responseText when errored.",
    //     apiCallTimeEndToEnd
    //   );
    //
    //   var logs = {
    //     "status": 999,
    //     "method": method,
    //     "ok": false,
    //     "url": fullURL,
    //     "reqBody": reqBody,
    //     "reqHeaders": reqHeaders,
    //     "originalError": request.statusText,
    //     "filename": "first-application.jsx"
    //   };
    //   LogErrorsToZoomCloud.sendLogs(logs, reqBody, reqHeaders);
    //
    //   UserHandler.setErrorMessage("There was an error (1701) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
    //   localContextThis.context.router.push("/signin");
    //   return;
    // };
    //
    // request.onload = function() {
    //   UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onload 1");
    //   var apiCallTimeEndToEnd = Date.now() - requestStartTime;
    //
    //   UserHandler.logToLogglyWithAPIResponse(
    //     "first-application.jsx - createFirstApplication - onload 2",
    //     method,
    //     fullURL,
    //     reqHeaders,
    //     reqBody,
    //     request.responseText,
    //     apiCallTimeEndToEnd
    //   );
    //
    //   //
    //   // Check response for non-happy-path flags
    //   //
    //   var responseJSON;
    //   try {
    //     responseJSON = JSON.parse(request.responseText);
    //   }
    //   catch (e) {
    //     UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onload - JSON.parse error - fatal - 1702 - error: " + e);
    //     var logs = {
    //       "status": 999,
    //       "method": method,
    //       "ok": false,
    //       "url": fullURL,
    //       "reqBody": reqBody,
    //       "reqHeaders": reqHeaders,
    //       "originalError": request.statusText,
    //       "filename": "first-application.jsx"
    //     };
    //     LogErrrorsToZoomCloud.sendLogs(logs, reqBody, reqHeaders);
    //     UserHandler.setErrorMessage("There was an error (1702) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
    //     localContextThis.context.router.push("/signin");
    //     return;
    //   }
    //
    //   if(!responseJSON.meta || !responseJSON.meta.ok) {
    //     //
    //     // Check to see if ok exists but is false.  also check to make sure there is a message.
    //     // this is the case of "expected error"
    //     // we should show what this is to the user since it could be
    //     // something like their auth token has already been used (common)
    //     //
    //     if(responseJSON.meta.ok === false) {
    //       UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onload - meta response not ok - fatal - 1703");
    //       UserHandler.setErrorMessage("There was an error (1703) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
    //       localContextThis.context.router.push("/signin");
    //       return;
    //     }
    //     else {
    //       UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onload - malformed response meta - fatal - 1705");
    //       UserHandler.setErrorMessage("There was an error (1703) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
    //       localContextThis.context.router.push("/signin");
    //       return;
    //     }
    //   }
    //
    //   if(!responseJSON || !responseJSON.data || !responseJSON.data.userToken) {
    //     UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - onload - email send response incorrect 2 - fatal - 1710");
    //     UserHandler.setErrorMessage("There was an error (1710) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.");
    //     localContextThis.context.router.push("/signin");
    //     return;
    //   }
    //
    //   let userAndAppDataForLocalStorage = {
    //     appToken: responseJSON.data.appToken,
    //     userToken: responseJSON.data.userToken,
    //     applicationName: responseJSON.data.name,
    //     applicationIcon: responseJSON.data.icon,
    //     role: "owner",
    //     key: 0
    //   };
    //
    //   // complete signup process
    //   if(localStorage.getItem("zoom_sdk_accepted_terms_and_conditions") !== true) {
    //     localStorage.setItem("zoom_sdk_temp_available_applications", JSON.stringify([userAndAppDataForLocalStorage]));
    //     localStorage.removeItem("zoom_sdk_available_applications");
    //     localStorage.setItem("zoom_sdk_temp_current_application", JSON.stringify(userAndAppDataForLocalStorage));
    //     localStorage.removeItem("zoom_sdk_current_application");
    //     localStorage.removeItem("zoom_sdk_accepted_terms_and_conditions");
    //
    //     localContextThis.context.router.push("/complete-signup");
    //     return;
    //   }
    //   else {
    //     localStorage.setItem("zoom_sdk_available_applications", JSON.stringify([userAndAppDataForLocalStorage]));
    //     localStorage.setItem("zoom_sdk_current_application", JSON.stringify(userAndAppDataForLocalStorage));
    //     localContextThis.context.router.push("/docs");
    //     return;
    //   }
    // };
    //
    // request.send(JSON.stringify(reqBody));
    // UserHandler.logToLogglySimple("first-application.jsx - createFirstApplication - sent");
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/first-application.jsx